import { createSelector } from 'reselect';

const selectBankStatementUploaderDomain = () => state =>
  state.get('bankStatementUploader').toJS();

export const makeSelectBankStatement = () =>
  createSelector(selectBankStatementUploaderDomain(), substate => substate.file);

export default makeSelectBankStatement;
